export const FOOTER_DETAILS = {
  ammendedBy: 'Chapter 389',
  ammendedSession: '2021 General Session',
};

export const HEADER_DETAILS = {
  chapterCode: '2',
  chapter: 'Property Tax Act',
  effective: '5/5/2021',
  part: 'County Assessment',
  partCode: '3',
  section:
    'Refusal by taxpayer to file signed statement -- Penalty -- Assessor to estimate value -- Reporting information to other counties.',
  sectionCode: '307',
  superseded: '1/1/2023',
  titleCode: '59',
  title: 'Revenue and Taxation',
};
